import { render, staticRenderFns } from "./TwitterAnalyticsPublicChartFollower.vue?vue&type=template&id=847a5c8e"
import script from "./TwitterAnalyticsPublicChartFollower.vue?vue&type=script&lang=ts"
export * from "./TwitterAnalyticsPublicChartFollower.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports